import React, {useState, useEffect} from 'react';

import {
    AnnotationIcon,
} from '@heroicons/react/solid';

import {Button, Spinner, Modal} from 'player-components';




import './style.css';


const IOSModal = ({onClose, onSubmit}) => {

    const renderContent = () => {
        return <div>
        
        <p>To play this song, you currently need to download our iOS native app.</p>
        <a href="https://apps.apple.com/gb/app/bimmplayer/id1109502471"><img className="chromeIcon" align="center" alt="Update iOS" src={`${process.env.PUBLIC_URL}/images/appstore.svg`} /></a>
        <p>We will be adding full iOS web support soon.</p>
        </div>
    }

    const handleClose = () => {
        onClose()
    }

    

return <Modal 
    isOpen={true}
    title="Download app"
    content={renderContent()}
    // icon={<AnnotationIcon className="h-6 w-6 text-primary" aria-hidden="true" />}
    onClose={handleClose}
    confirmLabel="Okay"
    onConfirm={handleClose}
    autoFocus={false}
    />

}


export default IOSModal;